import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';

@Component({
  selector: 'app-deposito-efectivo-declaracion',
  templateUrl: './declaracion.component.html',
  styleUrls: ['./declaracion.component.scss']
})
export class DeclaracionComponent implements OnInit {

  // Inputs
  @Input() isVisible: boolean = false

  // Outputs

  // forms  
  formDeclaracion: FormGroup

  // Data & Tmp
  total: number = 0

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder
  ) {
    this.log = this.clog.log('DEPOSITO-EFECTIVO-DECLARACION')
  }

  ngOnInit() {
    this.createForm()
    this.formChangesSubscriptions()
  }

  private createForm() {
    this.formDeclaracion = this.fb.group({
      valor20M: [null, []],
      valor10M: [null, []],
      valor05M: [null, []],
      valor02M: [null, []],
      valor01M: [null, []],
      valor500: [null, []],
      valor100: [null, []],
      valor050: [null, []],
      valor010: [null, []],
      valor005: [null, []],
      valor001: [null, []],
    });
  }

  formMaps = {
    valor20M: 20000,
    valor10M: 10000,
    valor05M: 5000,
    valor02M: 2000,
    valor01M: 1000,
    valor500: 500,
    valor100: 100,
    valor050: 50,
    valor010: 10,
    valor005: 5,
    valor001: 1,
  }

  private formChangesSubscriptions() {
    Object.keys(this.formDeclaracion.controls).forEach(field => {
      const control = this.formDeclaracion.get(field);
      control.valueChanges.subscribe(valor => this.calcularTotal())
    });
  }

  calcularTotal() {
    // TODO: Aqu� debe calcular el ponderado: Ej 20.000 valor 2 => 20.000 * 2 = 40.000
    this.total = 0
    Object.keys(this.formDeclaracion.controls).forEach(field => {
      const control = this.formDeclaracion.get(field);
      if (control.value)
        this.total += this.formMaps[field] * Number(control.value)
    });
  }

  public getTotal() {
    return this.total
  }

  public clear() {
    this.formDeclaracion.reset()
    this.formDeclaracion.get('valor20M').setValue(null)
    this.formDeclaracion.get('valor10M').setValue(null)
    this.formDeclaracion.get('valor05M').setValue(null)
    this.formDeclaracion.get('valor02M').setValue(null)
    this.formDeclaracion.get('valor01M').setValue(null)
    this.formDeclaracion.get('valor500').setValue(null)
    this.formDeclaracion.get('valor100').setValue(null)
    this.formDeclaracion.get('valor050').setValue(null)
    this.formDeclaracion.get('valor010').setValue(null)
    this.formDeclaracion.get('valor005').setValue(null)
    this.formDeclaracion.get('valor001').setValue(null)
    this.formDeclaracion.markAsUntouched()
    this.formDeclaracion.markAsPristine()
  }

}
